export default function ActivityHistory({ audit }) {
    return (
        <details className="po-panel">
            <summary>Activity history</summary>
            <ol className="po-activity-list">
                {audit.map((entry) => (
                    <li key={`${entry.at}-${entry.action}-${entry.actor}`}>
                        {new Date(entry.at).toLocaleString()}
                        {' '}
                        ·
                        {' '}
                        {entry.action.replaceAll('_', ' ')}
                        {' '}
                        ·
                        {entry.actor}
                        {entry.detail ? ` · ${entry.detail}` : ''}
                    </li>
                ))}
            </ol>
        </details>
    );
}
